import type { ButtonProps } from "./types";
import clsx from "clsx";
import { Button as DsButton } from "@digdir/designsystemet-react";
import "./button.css";

export type { ButtonProps };

const Button = ({
	children,
	buttonText,
	variant = "primary",
	color = "primary",
	materialIconLeft,
	materialIconRight,
	iconOnly = false,
	className = "",
	...props
}: ButtonProps) => {
	const renderIcon = (icon: string) => (
		<span aria-hidden="true" className="materialIcon">
			{icon}
		</span>
	);

	return (
		<DsButton
			variant={variant}
			data-color={color}
			className={clsx("btn", className, { iconOnly })}
			{...props}
		>
			{materialIconLeft && renderIcon(materialIconLeft)}
			{buttonText ? <span>{buttonText}</span> : <>{children}</>}
			{materialIconRight && renderIcon(materialIconRight)}
		</DsButton>
	);
};

export default Button;
